import React from "react"
import { FlexBox } from "@components/wrapper"
import { Job } from "@interfaces/career"
import { CareerCard } from "@components/card"
import { useScreenSize } from "@lib/hooks"

interface OtherVacancyProps {
  relatedJobs: Job[]
}

export function OtherVacancies({ relatedJobs }: OtherVacancyProps) {
  const { deviceType } = useScreenSize()

  if (deviceType !== "mobile") {
    return (
      <section className="w-full bg-green pt-7 pb-[50px] flex">
        <div className="w-4/5 mx-auto">
          <h2 className="text-white font-semibold text-2.5xl mb-7">Lowongan Pekerjaan Lainnya</h2>

          <div className="grid grid-cols-3 gap-8">
            {relatedJobs.map((career, i) => (
              <CareerCard career={career} key={i} />
            ))}
          </div>
        </div>
      </section>
    )
  } else {
    return (
      <section className="pl-4 pt-4 pb-7 bg-green">
        <h2 className="text-white font-semibold mb-5">Lowongan Pekerjaan Lainnya</h2>

        <div className="slider-mobile">
          <FlexBox className="gap-5 pr-4 w-max">
            {relatedJobs.map((career: Job, id: number) => (
              <CareerCard career={career} key={id} customWidth="w-[75vw]" />
            ))}
          </FlexBox>
        </div>
      </section>
    )
  }
}
